var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-card"},[_c('div',{staticClass:"info"},[_vm._t("default")],2),_c('dots',{staticClass:"small left white"},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.$emit('dismiss', true)}}},[_vm._v("Hide this message")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }